import {
  animationFrameScheduler,
  endWith,
  interval,
  map,
  Observable,
  takeWhile
} from 'rxjs';

import { environment } from '@env';

import { INTERNAL_CURRENCY_CODE } from './constants';

declare global {
  interface Navigator {
    browserLanguage?: string;
    userLanguage?: string;
  }
}

type CurrenciesToLocales = {
  [k: string]: {
    locales: string[];
    countryCodes: string[];
  };
};

export const CURRENCY_SYMBOLS: Record<string, string> = {
  'AED': 'DH',
  'ARS': '$',
  'AUD': 'A$',
  'BGN': 'лв',
  'BRL': 'R$',
  'BTC': '₿',
  'BYN': 'Br',
  'CAD': 'C$',
  'CHF': '₣',
  'CNY': ' ¥',
  'CZK': 'Kč',
  'DKK': 'kr',
  'EUR': '€',
  'GBP': '£',
  'HKD': 'HK$',
  'HRK': 'Kn',
  'HUF': 'ƒ',
  'ILS': '₪',
  'JPY': '¥',
  'KES': 'KSh',
  'KZT': '₸',
  'MDL': 'L',
  'MXN': '$',
  'NOK': 'kr',
  'NZD': '$',
  'PLN': 'zł',
  'QAR': 'QR',
  'RON': 'lei',
  'RUB': '₽',
  'SAR': 'SR',
  'SEK': 'kr',
  'SGD': 'S$',
  'THB': '฿',
  'TRY': '₺',
  'UAH': '₴',
  'UGX': 'Ush',
  'USD': 'C',
  'UZS': 'U',
  'ZAR': 'R',
  [INTERNAL_CURRENCY_CODE]: 'CS'
};

const CURRENCIES_TO_LOCALES: CurrenciesToLocales = {
  'UAH': {
    locales: ['uk', 'ru-ua'],
    countryCodes: ['UA']
  },
  'RUB': {
    locales: [],
    countryCodes: ['RU']
  },
  'PLN': {
    locales: ['pl'],
    countryCodes: ['PL']
  },
  'BRL': {
    locales: ['pt_br'],
    countryCodes: ['BR']
  },
  'SEK': {
    locales: ['sv', 'se'],
    countryCodes: ['SE']
  }
};

export function guessCurrency(
  userLocale: string|null,
  userCountryCode: string|null,
  fallbackCurrency: string = environment.baseCurrency
): string {
  // detect by country code first
  if(null !== userCountryCode) {
    for(const currencyCode in CURRENCIES_TO_LOCALES) {
      const data = CURRENCIES_TO_LOCALES[currencyCode];

      if(data.countryCodes.includes(userCountryCode)) {
        return currencyCode;
      }
    }
  }

  // then detect by locale
  if(null !== userLocale) {
    for(const currencyCode in CURRENCIES_TO_LOCALES) {
      const data = CURRENCIES_TO_LOCALES[currencyCode];

      for(const key in data.locales) {
        const locale: string = data.locales[key];

        if(userLocale.startsWith(locale)) {
          return currencyCode;
        }
      }
    }
  }

  return fallbackCurrency;
}

// progress: 0-1 progress b: beginning value, c: change in value
// const easeOutExpo = (progress: number, b: number, c: number): number =>
//   c * (-(2 ** (-10 * progress)) + 1) * 1024 / 1023 + b;

export function animatedRender(
  endValue: number,
  startValue: number,
  duration: number
): Observable<number> {
  const startTime = animationFrameScheduler.now();
  // const countDown = startValue > endValue;

  return interval(1000 / 60, animationFrameScheduler).pipe(
    map(() => animationFrameScheduler.now() - startTime),
    map((elapsedTime) => elapsedTime / duration),
    takeWhile((progress) => progress <= 1),
    map((progress) => {
      return startValue + (endValue - startValue) * progress;
      /* if(countDown) {
        return startValue - easeOutExpo(progress, 0, startValue - endValue);
      }

      return easeOutExpo(progress, startValue, endValue - startValue);*/
    }),
    // make sure that last emitted value is count
    endWith(endValue)
  );
}
